// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/NeueFrutigerWorldW02-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-size: small;
}
html#root,
body#root,
#root#root {
  overflow: hidden;
}
body {
  font-family: 'NeueFrutigerWorldW02-Regular', 'sans-serif' !important;
  overflow: hidden;
}
body * {
  font-family: 'NeueFrutigerWorldW02-Regular', 'sans-serif' !important;
}
* {
  box-sizing: border-box;
}
@font-face {
  font-family: 'NeueFrutigerWorldW02-Regular';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #5a9dbf;
}
::-webkit-scrollbar-thumb:hover {
  background: #5a9dbf;
}
.d-flex {
  display: flex;
}
.d-inline-flex {
  display: inline-flex;
}
.d-block {
  display: block;
}
.d-inline-block {
  display: inline-block;
}
.d-inline {
  display: inline;
}
.flex-row {
  flex-direction: row;
}
.flex-column {
  flex-direction: column;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.flex-wrap {
  flex-wrap: wrap;
}
.squareSize {
  width: 100%;
  height: 100%;
}
.w-0 {
  width: 0%;
}
.w-25 {
  width: 25%;
}
.w-50 {
  width: 50%;
}
.w-100 {
  width: 100% !important;
}
.w-auto {
  width: auto;
}
.w-25ch {
  width: '25ch';
}
.w-10 {
  width: 10%;
}
.w-20 {
  width: 20%;
}
.w-40 {
  width: 40%;
}
.w-45 {
  width: 45%;
}
.w-90 {
  width: 90%;
}
.mw-0 {
  max-width: 0%;
}
.mw-25 {
  max-width: 25%;
}
.mw-50 {
  max-width: 50%;
}
.mw-100 {
  max-width: 100%;
}
.mw-10 {
  max-width: 10%;
}
.h-0 {
  height: 0%;
}
.h-25 {
  height: 25%;
}
.h-50 {
  height: 50%;
}
.h-100 {
  height: 100%;
}
.h-auto {
  height: auto;
}
.h-inherit {
  height: inherit;
}
.m-0 {
  margin: 0;
}
.mt-0 {
  margin-top: 0;
}
.mt-1em {
  margin-top: 1em !important;
}
.mr-0 {
  margin-right: 0;
}
.mb-0 {
  margin-bottom: 0;
}
.ml-0 {
  margin-left: 0;
}
.ml-10 {
  margin-left: 10px !important;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.p-0 {
  padding: 0px !important;
}
.p-5px {
  padding: 5px;
}
.p-10px {
  padding: 10px;
}
.p-20px {
  padding: 20px;
}
.p-15px {
  padding: 15px;
}
.p-1rem {
  padding: 1rem;
}
.pt-0 {
  padding-top: 0 !important;
}
.pt-1 {
  padding-top: 1em !important;
}
.pt-10 {
  padding-top: 10px !important;
}
.pl-0 {
  padding-left: 0;
}
.pl-2 {
  padding-left: 2px !important;
}
.pr-0 {
  padding-right: 0;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pb-1 {
  padding-bottom: 1em !important;
}
.pb-2 {
  padding-bottom: 2em !important;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.px-0 {
  padding-right: 0;
  padding-left: 0;
}
.overflow-auto {
  overflow: auto;
}
.overflowX-auto {
  overflow-x: auto;
}
.overflowY-auto {
  overflow-y: auto;
}
.text-left {
  text-align: left !important;
}
.align-start {
  align-items: flex-start !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.text-bold {
  font-weight: bold;
}
.ws-nowrap {
  white-space: nowrap !important;
}
.vertical-middle {
  vertical-align: middle;
}
.align-top {
  align-items: flex-start;
}
.align-center {
  align-items: center;
}
.alignself-center {
  align-self: center;
}
.alignself-start {
  align-self: self-start;
}
.justify-left {
  justify-content: left !important;
}
.justify-center {
  justify-content: center;
}
.justify-right {
  justify-content: right;
}
.justify-end {
  justify-content: flex-end;
}
.justify-spacebetween {
  justify-content: space-between;
}
.justify-start {
  justify-content: flex-start;
}
.cursor-move {
  cursor: move;
}
.warning {
  color: #ff9800 !important;
}
.bottomUnset {
  border-bottom: unset;
}
.rowFlex {
  display: flex;
  flex-direction: row;
}
.colFlex {
  display: flex;
  flex-direction: column;
}
.squareSize {
  width: 100%;
  height: 100%;
}
.flex-start {
  justify-content: flex-start;
  align-items: flex-start;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-default {
  cursor: default !important;
}
.position-absolute {
  position: absolute;
}
.overflow-hidden {
  overflow: hidden;
}
.overflowY-hidden {
  overflow-y: hidden;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
}
.overflowWrap-anywhere {
  overflow-wrap: anywhere;
}
.zindex-100 {
  z-index: 100;
}
.border-radius-0 {
  border-radius: 0 !important;
}
.bg-philips-blue {
  background-color: #1474a4;
}
.bg-lightgray {
  background-color: lightgray;
}
.b-0 {
  border: 0;
}
.PhilipsBlue {
  color: #1474a4;
}
.PhilipsRed {
  color: red;
}
.white-color {
  color: white;
}
.headerStyle.root {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.headerStyle .toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 10px;
  min-height: 3rem;
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
}
.headerStyle .toolbarSection {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.headerStyle .tooltip {
  margin: 2;
}
.headerStyle .button-icon {
  cursor: pointer;
  color: #ffffff;
}
.zoom80 {
  zoom: 80%;
}
.userPanelIconButton {
  cursor: pointer;
  color: white !important;
  padding: 5px !important;
}
.userPanelIconButton .userProfileIcon {
  height: 2rem;
  width: 2rem;
}
.popperStyle.arrow {
  width: 3em;
  height: 3em;
}
.popperStyle::before {
  content: '';
  margin: auto;
  display: block;
  width: 0%;
  border-style: solid;
  border-width: 0px 1em 1em;
  border-color: transparent transparent #ffffff;
  margin-top: -0.4rem;
}
.appRouter.root {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding: 0;
}
.appRouter .secondaryHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.appRouter .appRouterContent {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.appRouter .divider {
  width: 100%;
}
.footer.root {
  display: flex;
  width: 100% !important;
  font-size: 12px;
  justify-content: space-between;
  padding-left: 1em;
  padding-right: 1em;
}
.footer .env {
  margin-right: 1px;
  padding-right: 1px;
}
.footer .termsAndCondition {
  display: flex;
  flex-direction: row;
  margin-right: 1px;
}
.footer.bg-gray {
  background-color: #eeeeee;
}
.footer.bg-green {
  background-color: #93c47d;
}
.footer.bg-orange {
  background-color: #f6b26b;
}
.footer.bg-yellow {
  background-color: #f3f66b;
}
.termsAndCondition-dialog .paperClass {
  width: 45%;
  height: 60vh;
}
.termsAndConditionStyle {
  display: flex;
  flex-direction: row;
  margin-right: 1px;
}
.termsAndConditionStyle .title {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}
.drawerOpen {
  width: 200px;
}
.middle-container {
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100% !important;
  height: 100%;
  padding: 0.4em 1.5em;
}
.middle-container .mainHeader {
  margin-top: 0em;
  margin-bottom: 0.2em;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-tabs {
  text-transform: capitalize !important;
  align-items: center;
  justify-content: left !important;
  text-align: left !important;
  min-height: 50px;
  padding: 10px;
  color: rgba(0, 0, 0, 0.87) !important;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.tab-drawer-tabs {
  color: #1474a4 !important;
  background: #c7e0f4 !important;
  font-weight: 800 !important;
}
.navigateTabLabel {
  writing-mode: tb-rl;
  height: inherit;
  cursor: pointer;
  font-size: 1.25rem;
  white-space: nowrap;
}
.tabDrawerMini {
  width: 3.5rem;
  height: inherit;
  text-align: center;
  background: #eeeeee;
  z-index: 100;
}
.pinIcon {
  font-size: 1.4rem !important;
}
.rotate180 {
  transform: rotate(180deg);
}
.rotate270 {
  transform: rotate(270deg);
}
.rotate90 {
  transform: rotate(90deg);
}
.rotate0 {
  transform: rotate(0deg);
}
.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium.left-arrow {
  color: #1474a4;
  margin-left: 80%;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-tabs:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.toggleIcon:hover {
  width: inherit !important;
  border-radius: 0 !important;
}
.toggleIcon:focus {
  width: inherit !important;
  border-radius: 0 !important;
}
.text-align-end {
  text-align: end;
}
.data-table {
  margin-top: 0.5em;
}
.common-data-table {
  height: 78% !important;
}
.common-data-table .MuiTableCell-head {
  font-weight: 500;
  font-size: 14px;
}
.common-data-table .link {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}
.delete-button {
  text-transform: capitalize !important;
  color: red;
}
.common-dialog-style .header {
  background-color: #1474a4;
  font-size: 1.2rem;
  padding: 0.5rem;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: white;
}
.common-dialog-style .paper {
  height: 60vh;
}
.common-dialog-style .dialogContent {
  padding-top: 4vh !important;
}
.common-dialog-style .closeIcon {
  position: absolute;
  right: 0px;
  top: 0px;
  color: white;
}
.common-dialog-style .footer {
  background: #eeeeee;
  border-top: 0.1rem solid rgba(0, 0, 0, 0.12);
}
.alert-dialog .MuiDialog-container .MuiPaper-root {
  min-width: 30%;
}
.alert-dialog .MuiDialog-container .MuiPaper-root .MuiDialogContent-root {
  padding-top: 1.5em;
}
.alert-dialog .alertDialogContents {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.alert-dialog .alertDialogContents .alertIcon {
  display: flex;
  margin-right: 5%;
  transform: scale(1.3);
}
.iframeDialogStyle .MuiPaper-root {
  width: 80% !important;
  height: 90vh !important;
  max-width: 100% !important;
}
.iframeDialogStyle .closeIcon {
  position: absolute;
  right: 0px;
  top: 0px;
  color: #fff;
}
.iframeDialogStyle .header {
  background-color: #1474a4;
  font-size: 1.2rem;
  padding: 0.5rem;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: white;
}
.iframeDialogStyle .MuiDialogContent-root {
  padding: 5px !important;
}
.manipulationDialog .MuiPaper-root {
  width: 40%;
  min-height: 50%;
  height: 50%;
  max-height: 70%;
  max-width: 100%;
}
.manipulationDialog .title {
  height: auto;
  text-align: left;
}
.manipulationDialog .MuiAlert-root {
  height: auto !important;
  width: auto !important;
}
.xLargerDialog .MuiPaper-root {
  width: 70% !important;
  height: 80% !important;
}
.xLargerDialog .detailsTable {
  margin-top: 1vh !important;
  height: 64vh !important;
  width: 100% !important;
}
.xLargerDialog .detailsTable .MuiTableCell-head {
  padding: 5px;
}
.xLargerDialog .detailsTable .MuiTableCell-body {
  padding: 5px;
}
.xLargerDialog .detailsTable div {
  position: absolute;
  width: max-content;
  margin: 18% 0 0 40%;
}
.largerManipulationDialog .MuiPaper-root {
  width: 60% !important;
  min-height: 50%;
  height: 80% !important;
  max-height: 80% !important;
}
.largerManipulationDialog .featureFlagsTab {
  padding: 0px !important;
}
.largerManipulationDialog .featureFlagsTab .featureFlagsTable {
  height: 50vh !important;
  margin-top: 0px !important;
  width: 100% !important;
  overflow-x: hidden;
}
.largerManipulationDialog .permissionsTab .api-data-table {
  height: 55vh !important;
  margin-top: 0px !important;
  width: 100% !important;
  overflow-x: hidden;
}
.rolesChip {
  margin-right: 0.5em;
}
.alert-box {
  width: inherit;
  position: absolute;
  display: flex;
  justify-content: center;
}
.alert-box .alert {
  width: 30%;
}
.MuiAlert-message {
  overflow: hidden !important;
}
.formActionButtons {
  display: flex;
  justify-content: flex-end;
  bottom: 0;
  position: absolute;
  width: 100%;
  left: 0;
  padding-bottom: 1em;
  background-color: #fff;
  z-index: 100;
}
.formActionButtons button {
  margin-right: 0.5em;
}
.manipulationForm .errorMessage {
  margin-top: 0.5vh;
  width: 100% !important;
  max-height: 100% !important;
  align-items: center;
}
.manipulationBox {
  width: 100%;
}
.userManipulationTabs {
  width: 100%;
}
.userManipulationTabs .dialog-tab {
  padding-left: 1%;
  padding-right: 1%;
}
.userManipulationTabs .personalDetailsTab {
  display: inline;
  padding-bottom: 0px !important;
}
.userManipulationTabs .personalDetailsTab .personalDetailsForm .errorMessage {
  margin-top: 0.5vh;
}
.userManipulationTabs .roleAssociationTab {
  padding: 0px !important;
  width: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.userManipulationTabs .roleAssociationTab .data-table {
  height: auto !important;
  margin-top: 0px !important;
  width: 100% !important;
}
.userManipulationTabs .roleAssociationTab .data-table .MuiTableCell-head {
  padding: 0px !important;
}
.userManipulationTabs .roleAssociationTab .data-table .MuiTableCell-body {
  padding: 0px !important;
}
.userManipulationTabs .roleAssociationTab .formActionButtons {
  padding-top: 1em;
}
.userManipulationTabs .permissionsTab {
  padding: 0px !important;
}
.userManipulationTabs .permissionsTab .MuiPaper-root {
  min-width: 100% !important;
  min-height: 52vh !important;
}
.userManipulationTabs .permissionsTab .data-table {
  height: 40vh !important;
  margin-top: 0px !important;
}
.noDataFound {
  text-align: center !important;
}
.searchIconForColumn {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.search-bar.MuiAutocomplete-root {
  width: 20em !important;
  position: relative;
  bottom: 3px;
  padding-top: 0.3rem;
}
.search-bar.MuiAutocomplete-root .search-inner-text > div {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  margin-left: 0.7vw;
}
.search-bar.MuiAutocomplete-root .search-inner-text > div > div > button {
  visibility: visible !important;
}
.search-bar.MuiAutocomplete-root .search-inner-text > div > div > svg {
  position: absolute !important;
  top: 1.1vh !important;
  left: 0.2vw !important;
}
iframe {
  width: 100%;
  height: 98%;
  border: 0px;
}
.warningIcon {
  color: #f7d368;
}
.successIcon {
  color: #93c47d;
}
.headerDialog {
  background: #1474a4;
  font-size: 1.2rem !important;
  padding: 0.5rem !important;
  color: white;
}
.dialog-content {
  padding-top: 1em !important;
  padding-bottom: 1em !important;
}
.exportIcon {
  color: #1474a4 !important;
}
.checkboxDropdown {
  padding: 0px !important;
  padding-right: 1% !important;
}
.inputFieldset {
  box-sizing: border-box;
  border-radius: 4px;
  border-width: 1.5px;
  border-color: rgba(0, 0, 0, 0.2);
  border-style: solid;
  width: 100%;
  height: fit-content;
  padding-bottom: 4px !important;
  padding-left: 0.8rem !important;
  margin-inline-start: 0px !important;
}
.inputFieldset:hover:not(:focus):not(:focus-within) {
  border-color: rgba(0, 0, 0, 0.87);
}
.inputFieldset:focus-within {
  border-color: #1173a3;
}
.inputFieldset > legend.inputLegend {
  color: rgba(0, 0, 0, 0.6);
  word-break: break-all;
}
.inputFieldset:focus-within > legend.inputLegend {
  color: #1474a4;
}
.inputFieldset:hover:not(:focus):not(:focus-within) > legend.inputLegend {
  color: rgba(0, 0, 0, 0.87);
}
.inputFieldset .success-dialog .MuiDialog-paper {
  max-width: 600px !important;
}
.inputFieldset .success-dialog .apiKey {
  max-width: 60ch;
  overflow: hidden;
  text-overflow: ellipsis;
}
.maintenanceTable {
  height: 86%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.maintenanceTable .recordPicker {
  position: relative;
  bottom: 3px;
  padding-top: 0.3rem;
  padding-left: 0.3rem;
}
.maintenanceTable .common-data-table .MuiTableCell-head,
.maintenanceTable .common-data-table .MuiTableCell-body {
  padding: 0.5rem 0 0.5rem 1rem;
}
.maintenanceTable .common-data-table .MuiTableCell-head {
  min-width: 65;
}
.dialog-mode {
  height: 100% !important;
  padding-top: 10px;
}
.statusFailed {
  background-color: #ffa07a73;
}
.statusFailed:hover:not(:focus):not(:focus-within) {
  background-color: #ffa07a73;
}
.link {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}
.show-alert {
  position: absolute;
  top: 18px;
  z-index: 100;
  width: 90%;
}
.text-area {
  border-radius: 4px;
  border-width: 1.5px;
  border-color: rgba(0, 0, 0, 0.2);
}
.unsupported-browser {
  display: inline-block;
  text-align: center;
  width: 45%;
  height: 90%;
  margin-left: auto;
  margin-right: auto;
}
.unsupported-browser .message {
  text-align: left;
  padding-top: 5px !important;
}
.unsupported-browser .unsupported-browser-image {
  height: 50;
  width: 40;
}
.unsupported-browser .versionSupported {
  z-index: 150000 !important;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.unsupported-browser .versionSupported .browserBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 2%;
  justify-content: space-between;
}
.unsupported-browser .versionSupported .browserBox img {
  height: 35px;
  width: 35px;
}
.unsupported-browser .versionSupported .browserBox .browserDetails {
  display: flex;
  flex-direction: column;
}
.common-btn {
  height: 2.5rem;
}
.priceListMapSearchBar {
  display: flex;
  flex-direction: row;
}
.priceListMapSearchBar .records {
  align-self: center;
  margin-left: 2%;
}
.headerLogo {
  cursor: pointer !important;
}
.cellWithValueAsNo {
  background-color: pink;
  color: red;
}
.circularProgress-upload {
  animation: blink 1s linear infinite;
}
.loading-message {
  display: block;
  text-align: center;
  background: white;
  padding: 50px;
  box-shadow: 1px 1px 2px 1px grey;
  border-radius: 3px;
  width: 30%;
  min-width: 30%;
}
.squareLegend {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.circleLegend {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 5px;
}
.updateCell .removed {
  color: red;
  text-decoration: line-through;
}
.updateCell .added {
  color: green;
}
.cellStylesPHAdded {
  background-color: lightgreen;
}
.cellStylesPHDeleted {
  background-color: pink;
}
.cellStylesPHUpdated {
  background-color: yellow;
}
.span-overflow {
  display: inline-block;
  max-width: 38%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  top: 15%;
}
.file-upload-box {
  display: contents;
}
.tabpanel-manipulation {
  width: 100%;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.permission-tab-panel {
  color: #1474a4 !important;
  background: #c7e0f4 !important;
  font-weight: 800 !important;
  justify-content: center !important;
}
.selected-enum-option {
  cursor: pointer;
  padding: 3px;
  background: lightblue;
}
.default-enum-option {
  cursor: pointer;
  padding: 2px;
}
.default-enum-option:hover {
  background: lightblue;
  cursor: pointer;
  padding: 3px;
  animation: inputHighlighter 0.3s ease;
}
.application-radio {
  margin-right: 5px !important;
}
.technical-info {
  margin-right: 0.5em;
  margin-top: 0.2em !important;
}
.feature-association-header {
  margin-top: 0em;
  margin-bottom: 0.2em;
}
.asterisk {
  color: red;
}
.property-header {
  background: #faebd7;
}
.checkbox-grid-2col {
  display: grid;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
  gap: 8px;
}
.checkbox-grid-3col {
  display: grid;
  grid-template-columns: repeat(3, minmax(139px, 1fr));
}
/* 
  ##Device = Ipad mini (portrait)
  ##Screen = B/w 768px to 1024px
*/
@media all and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {
  .largerManipulationDialog .MuiPaper-root {
    min-width: 80% !important;
    width: 80% !important;
    min-height: 50%;
    height: 80% !important;
    max-height: 80% !important;
  }
  .manipulationDialog .MuiPaper-root {
    width: 50%;
    min-height: 40%;
    height: 40%;
    max-height: 60%;
    max-width: 70%;
  }
}
@media all and (device-width: 1024px) and (device-height: 768px) and (orientation: landscape) {
  .largerManipulationDialog .MuiPaper-root {
    width: 70% !important;
    min-height: 50%;
    height: 80% !important;
    max-height: 80% !important;
  }
  .manipulationDialog .MuiPaper-root {
    width: 45%;
    min-height: 50%;
    height: 50%;
    max-height: 60%;
    max-width: 70%;
  }
}
/* 
  ##Device = Ipad Air (portrait)
  ##Screen = B/w 820px to 1180px
*/
@media all and (device-width: 820px) and (device-height: 1180px) and (orientation: portrait) {
  .largerManipulationDialog .MuiPaper-root {
    min-width: 80% !important;
    width: 80% !important;
    min-height: 50%;
    height: 70% !important;
    max-height: 80% !important;
  }
  .manipulationDialog .MuiPaper-root {
    width: 50%;
    min-height: 40%;
    height: 40%;
    max-height: 60%;
    max-width: 70%;
  }
}
@media all and (device-width: 1180px) and (device-height: 820px) and (orientation: landscape) {
  .largerManipulationDialog .MuiPaper-root {
    width: 70% !important;
    min-height: 50%;
    height: 80% !important;
    max-height: 80% !important;
  }
  .manipulationDialog .MuiPaper-root {
    width: 45%;
    min-height: 50%;
    height: 50%;
    max-height: 60%;
    max-width: 70%;
  }
}
/* 
  ##Device = Ipad Air (portrait)
  ##Screen = B/w  1024px to 1366px
*/
@media all and (device-width: 1024px) and (device-height: 1366px) and (orientation: portrait) {
  .largerManipulationDialog .MuiPaper-root {
    min-width: 80% !important;
    width: 80% !important;
    min-height: 50%;
    height: 70% !important;
    max-height: 80% !important;
  }
  .manipulationDialog .MuiPaper-root {
    width: 50%;
    min-height: 35%;
    height: 35%;
    max-height: 60%;
    max-width: 65%;
  }
}
@media all and (device-width: 1366px) and (device-height: 1024px) and (orientation: landscape) {
  .largerManipulationDialog .MuiPaper-root {
    width: 70% !important;
    min-height: 50%;
    height: 80% !important;
    max-height: 80% !important;
  }
  .manipulationDialog .MuiPaper-root {
    width: 40%;
    min-height: 35%;
    height: 35%;
    max-height: 60%;
    max-width: 65%;
  }
}
.formLabel-login-error {
  cursor: pointer;
  font-weight: bold !important;
  text-decoration: underline;
  color: black !important;
}
.btn-plain {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  font: inherit;
  font-family: inherit;
  font-weight: inherit;
}
.hide {
  display: none;
}
fieldset[disabled] {
  border-color: rgba(0, 0, 0, 0.2) !important;
}
fieldset[disabled] input,
fieldset[disabled] legend,
fieldset[disabled] .inputLegend,
fieldset[disabled] span {
  cursor: default;
  color: rgba(0, 0, 0, 0.38) !important;
}
fieldset[disabled] .asterisk {
  color: red !important;
}
fieldset[disabled] span:hover {
  background-color: transparent !important;
}
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(139px, 1fr));
}
.property-clear-icon-wrapper {
  margin-right: 16px;
  opacity: 0;
  transition: opacity 0.2s;
}
.MuiSelect-select:hover ~ .property-clear-icon-wrapper {
  opacity: 1;
}
.property-clear-icon-wrapper:hover {
  opacity: 1;
}
.property-type-restrict-message {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./style/index.less"],"names":[],"mappings":"AAAA;;;EAGE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AACF;AACE;;;EACE,gBAAA;AAGJ;AACA;EACE,oEAAA;EACA,gBAAA;AACF;AAEA;EACE,oEAAA;AAAF;AAEA;EACE,sBAAA;AAAF;AAWA;EACE,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;AATF;AAaA;EACE,UAAA;EACA,WAAA;AAXF;AAaA;EACE,mBAAA;AAXF;AAaA;EACE,mBAAA;AAXF;AAaA;EACE,mBAAA;AAXF;AAaA;EACE,aAAA;AAXF;AAcA;EACE,oBAAA;AAZF;AAeA;EACE,cAAA;AAbF;AAgBA;EACE,qBAAA;AAdF;AAiBA;EACE,eAAA;AAfF;AAkBA;EACE,mBAAA;AAhBF;AAmBA;EACE,sBAAA;AAjBF;AAoBA;EACE,iBAAA;AAlBF;AAqBA;EACE,eAAA;AAnBF;AAsBA;EACE,WAAA;EACA,YAAA;AApBF;AAuBA;EACE,SAAA;AArBF;AAwBA;EACE,UAAA;AAtBF;AAyBA;EACE,UAAA;AAvBF;AA0BA;EACE,sBAAA;AAxBF;AA2BA;EACE,WAAA;AAzBF;AA4BA;EACE,aAAA;AA1BF;AA6BA;EACE,UAAA;AA3BF;AA8BA;EACE,UAAA;AA5BF;AA+BA;EACE,UAAA;AA7BF;AAgCA;EACE,UAAA;AA9BF;AAiCA;EACE,UAAA;AA/BF;AAkCA;EACE,aAAA;AAhCF;AAmCA;EACE,cAAA;AAjCF;AAoCA;EACE,cAAA;AAlCF;AAqCA;EACE,eAAA;AAnCF;AAsCA;EACE,cAAA;AApCF;AAuCA;EACE,UAAA;AArCF;AAwCA;EACE,WAAA;AAtCF;AAyCA;EACE,WAAA;AAvCF;AA0CA;EACE,YAAA;AAxCF;AA2CA;EACE,YAAA;AAzCF;AA2CA;EACE,eAAA;AAzCF;AA2CA;EACE,SAAA;AAzCF;AA4CA;EACE,aAAA;AA1CF;AA4CA;EACE,0BAAA;AA1CF;AA4CA;EACE,eAAA;AA1CF;AA6CA;EACE,gBAAA;AA3CF;AA8CA;EACE,cAAA;AA5CF;AA+CA;EACE,4BAAA;AA7CF;AAgDA;EACE,iBAAA;EACA,kBAAA;AA9CF;AAiDA;EACE,uBAAA;AA/CF;AAkDA;EACE,YAAA;AAhDF;AAmDA;EACE,aAAA;AAjDF;AAoDA;EACE,aAAA;AAlDF;AAqDA;EACE,aAAA;AAnDF;AAsDA;EACE,aAAA;AApDF;AAuDA;EACE,yBAAA;AArDF;AAuDA;EACE,2BAAA;AArDF;AAwDA;EACE,4BAAA;AAtDF;AAyDA;EACE,eAAA;AAvDF;AAyDA;EACE,4BAAA;AAvDF;AA0DA;EACE,gBAAA;AAxDF;AA2DA;EACE,4BAAA;AAzDF;AA2DA;EACE,8BAAA;AAzDF;AA4DA;EACE,8BAAA;AA1DF;AA6DA;EAhCE,yBAAA;EAsBA,4BAAA;AA/CF;AA8DA;EAnBE,gBAAA;EAPA,eAAA;AAhCF;AA+DA;EACE,cAAA;AA7DF;AAgEA;EACE,gBAAA;AA9DF;AAiEA;EACE,gBAAA;AA/DF;AAkEA;EACE,2BAAA;AAhEF;AAmEA;EACE,kCAAA;AAjEF;AAoEA;EACE,4BAAA;AAlEF;AAqEA;EACE,kBAAA;AAnEF;AAsEA;EACE,qCAAA;AApEF;AAuEA;EACE,iBAAA;AArEF;AAwEA;EACE,8BAAA;AAtEF;AAyEA;EACE,sBAAA;AAvEF;AA0EA;EACE,uBAAA;AAxEF;AA2EA;EACE,mBAAA;AAzEF;AA4EA;EACE,kBAAA;AA1EF;AA6EA;EACE,sBAAA;AA3EF;AA8EA;EACE,gCAAA;AA5EF;AA+EA;EACE,uBAAA;AA7EF;AAgFA;EACE,sBAAA;AA9EF;AAgFA;EACE,yBAAA;AA9EF;AAgFA;EACE,8BAAA;AA9EF;AAiFA;EACE,2BAAA;AA/EF;AAkFA;EACE,YAAA;AAhFF;AAmFA;EACE,yBAAA;AAjFF;AAoFA;EACE,oBAAA;AAlFF;AAqFA;EA9TE,aAAA;EAoBA,mBAAA;AAyNF;AAsFA;EAnUE,aAAA;EAwBA,sBAAA;AAyNF;AAuFA;EACE,WAAA;EACA,YAAA;AArFF;AAwFA;EACE,2BAAA;EACA,uBAAA;AAtFF;AAyFA;EACE,eAAA;AAvFF;AA0FA;EACE,0BAAA;AAxFF;AA2FA;EACE,kBAAA;AAzFF;AA4FA;EACE,gBAAA;AA1FF;AA6FA;EACE,kBAAA;AA3FF;AA8FA;EACE,uBAAA;AA5FF;AA+FA;EACE,uBAAA;AA7FF;AAgGA;EACE,YAAA;AA9FF;AAiGA;EACE,2BAAA;AA/FF;AAkGA;EACE,yBAAA;AAhGF;AAmGA;EACE,2BAAA;AAjGF;AAoGA;EACE,SAAA;AAlGF;AAqGA;EACE,cAAA;AAnGF;AAqGA;EACE,UAAA;AAnGF;AAsGA;EACE,YAAA;AApGF;AAwGE;EA9YA,aAAA;EAoBA,mBAAA;EA0TA,2BAAA;EACA,uBAAA;AAnCF;AAiGA;EA7YE,aAAA;EAoBA,mBAAA;EAiYE,8BAAA;EACA,mBAAA;EA7EF,WAAA;EACA,YAAA;EA8EE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,iCAAA;AAnGJ;AAqFA;EA7YE,aAAA;EAoBA,mBAAA;EA4YE,2BAAA;EACA,mBAAA;AAnGJ;AA+EA;EAwBI,SAAA;AApGJ;AA4EA;EA1DE,eAAA;EAuFE,cAAA;AArGJ;AAwGA;EACE,SAAA;AAtGF;AAyGA;EA9FE,eAAA;EAgGA,uBAAA;EAjRA,uBAAA;AA2KF;AAoGA;EAMI,YAAA;EACA,WAAA;AAvGJ;AA4GE;EACE,UAAA;EACA,WAAA;AA1GJ;AA6GE;EACE,WAAA;EACA,YAAA;EA5bF,cAAA;EAiCA,SAAA;EA8ZE,mBAAA;EACA,yBAAA;EACA,6CAAA;EACA,mBAAA;AA3GJ;AA+GE;EA9cA,aAAA;EAwBA,sBAAA;EAsTA,2BAAA;EACA,uBAAA;EANA,WAAA;EACA,YAAA;EAwIE,UAAA;AA1GJ;AAqGA;EA7cE,aAAA;EAoBA,mBAAA;EAuRA,8BAAA;EA1BA,mBAAA;EAyME,WAAA;AA3GJ;AA8FA;EA7cE,aAAA;EAoBA,mBAAA;EAuRA,8BAAA;EA8BA,WAAA;EACA,YAAA;EAwJE,gBAAA;AA3GJ;AAsFA;EAyBI,WAAA;AA5GJ;AAgHE;EA1eA,aAAA;EAqDA,sBAAA;EAwbE,eAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AA9GJ;AAuGA;EAWI,iBAAA;EACA,kBAAA;AA/GJ;AAmGA;EAzeE,aAAA;EAoBA,mBAAA;EAueE,iBAAA;AAhHJ;AAmHE;EACE,yBAAA;AAjHJ;AAoHE;EACE,yBAAA;AAlHJ;AAqHE;EACE,yBAAA;AAnHJ;AAsHE;EACE,yBAAA;AApHJ;AAwHA;EAEI,UAAA;EACA,YAAA;AAvHJ;AA2HA;EAthBE,aAAA;EAoBA,mBAAA;EAqgBA,iBAAA;AAzHF;AAsHA;EAnME,eAAA;EA0ME,0BAAA;EACA,WAAA;AAzHJ;AA4HA;EACE,YAAA;AA1HF;AA4HA;EAnUE,cAAA;EAqUA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;AA1HF;AAkHA;EAUI,eAAA;EACA,oBAAA;AAzHJ;AA4HA;EArTE,qCAAA;EAoBA,mBAAA;EAYA,gCAAA;EAhDA,2BAAA;EA0UA,gBAAA;EACA,aAAA;EACA,qCAAA;AA1HF;AA4HA;EACE,yBAAA;EACA,8BAAA;EACA,2BAAA;AA1HF;AA6HA;EACE,mBAAA;EACA,eAAA;EACA,eAAA;EAEA,kBAAA;EACA,mBAAA;AA5HF;AA+HA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AA7HF;AAgIA;EACE,4BAAA;AA9HF;AAiIA;EACE,yBAAA;AA/HF;AAkIA;EACE,yBAAA;AAhIF;AAmIA;EACE,wBAAA;AAjIF;AAoIA;EACE,uBAAA;AAlIF;AAqIA;EACE,cAAA;EACA,gBAAA;AAnIF;AAsIA;EACE,qCAAA;AApIF;AAuIA;EACE,yBAAA;EACA,2BAAA;AArIF;AAwIA;EACE,yBAAA;EACA,2BAAA;AAtIF;AAyIA;EACE,eAAA;AAvIF;AA0IA;EACE,iBAAA;AAxIF;AA2IA;EACE,sBAAA;AAzIF;AAwIA;EAGI,gBAAA;EACA,eAAA;AAxIJ;AAoIA;EA9SE,eAAA;EAsTE,0BAAA;EACA,WAAA;AAxIJ;AA4IA;EAjZE,qCAAA;EAmZA,UAAA;AA1IF;AA6IA;EA5RE,yBAAA;EA+RE,iBAAA;EACA,eAAA;EACA,+CAAA;EACA,YAAA;AA5IJ;AAsIA;EAUI,YAAA;AA7IJ;AAmIA;EAcI,2BAAA;AA9IJ;AAgIA;EAxTE,kBAAA;EA2UE,UAAA;EACA,QAAA;EACA,YAAA;AA/IJ;AA0HA;EAyBI,mBAAA;EACA,4CAAA;AAhJJ;AAoJA;EAEI,cAAA;AAnJJ;AAiJA;EAKI,kBAAA;AAnJJ;AA8IA;EAQI,aAAA;EACA,mBAAA;EACA,mBAAA;AAnJJ;AAyIA;EAYM,aAAA;EACA,gBAAA;EACA,qBAAA;AAlJN;AAuJA;EAEI,qBAAA;EACA,uBAAA;EACA,0BAAA;AAtJJ;AAkJA;EAzWE,kBAAA;EAiXE,UAAA;EACA,QAAA;EACA,WAAA;AAtJJ;AA4IA;EAaI,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,+CAAA;EACA,YAAA;AAtJJ;AAqIA;EAoBI,uBAAA;AAtJJ;AA0JA;EAEI,UAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAzJJ;AAmJA;EAnmBE,YAAA;EA6mBE,gBAAA;AAzJJ;AA+IA;EAaI,uBAAA;EACA,sBAAA;AAzJJ;AA6JA;EAEI,qBAAA;EACA,sBAAA;AA5JJ;AAyJA;EAMI,0BAAA;EACA,uBAAA;EACA,sBAAA;AA5JJ;AAoJA;EA5kBE,YAAA;AA2bF;AAiJA;EA5kBE,YAAA;AA8bF;AA8IA;EAgBM,kBAAA;EACA,kBAAA;EACA,mBAAA;AA3JN;AAgKA;EAEI,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;AA/JJ;AA0JA;EAvmBE,uBAAA;AAgdF;AAuJA;EAUM,uBAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;AA9JN;AAiJA;EAkBM,uBAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;AAhKN;AAqKA;EACE,mBAAA;AAnKF;AAsKA;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AApKF;AAgKA;EAMI,UAAA;AAnKJ;AAuKA;EACE,2BAAA;AArKF;AAwKA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AAtKF;AA6JA;EAWI,mBAAA;AArKJ;AAyKA;EAEI,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;AAxKJ;AA4KA;EACE,WAAA;AA1KF;AA6KA;EACE,WAAA;AA3KF;AA0KA;EAII,gBAAA;EACA,iBAAA;AA3KJ;AAsKA;EASI,eAAA;EACA,8BAAA;AA5KJ;AAkKA;EAcQ,iBAAA;AA7KR;AA+JA;EA/qBE,uBAAA;EAosBE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAhLJ;AAwJA;EA0BM,uBAAA;EACA,0BAAA;EACA,sBAAA;AA/KN;AAmJA;EA/qBE,uBAAA;AA+hBF;AAgJA;EA/qBE,uBAAA;AAkiBF;AA6IA;EAqCM,gBAAA;AA/KN;AA0IA;EA/qBE,uBAAA;AAwiBF;AAuIA;EA4CM,0BAAA;EACA,2BAAA;AAhLN;AAmIA;EAgDM,uBAAA;EACA,0BAAA;AAhLN;AAqLA;EA1oBE,6BAAA;AAwdF;AAsLA;EAv4BE,aAAA;EAoBA,mBAAA;EA6PA,mBAAA;AAqcF;AAsLA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AApLF;AAgLA;EAMI,2BAAA;EACA,8BAAA;EACA,kBAAA;AAnLJ;AA2KA;EAYI,8BAAA;AApLJ;AAwKA;EAgBI,6BAAA;EACA,qBAAA;EACA,sBAAA;AArLJ;AAyLA;EACE,WAAA;EACA,WAAA;EACA,WAAA;AAvLF;AA0LA;EACE,cAAA;AAxLF;AA2LA;EACE,cAAA;AAzLF;AA4LA;EACE,mBAAA;EACA,4BAAA;EACA,0BAAA;EACA,YAAA;AA1LF;AA6LA;EACE,2BAAA;EACA,8BAAA;AA3LF;AA8LA;EAzjBE,yBAAA;AA8XF;AA+LA;EAlyBE,uBAAA;EAoyBA,4BAAA;AA7LF;AAgMA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,mCAAA;AA9LF;AA+LE;EACE,iCAAA;AA7LJ;AA+LE;EACE,qBAAA;AA7LJ;AAgME;EACE,yBAAA;EACA,qBAAA;AA9LJ;AAgME;EACE,cAAA;AA9LJ;AAgME;EACE,0BAAA;AA9LJ;AAoKA;EA+BM,2BAAA;AAhMN;AAiKA;EAkCM,eAAA;EACA,gBAAA;EACA,uBAAA;AAhMN;AAqMA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAnMF;AA+LA;EAMI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;AAlMJ;AAyLA;;EAcM,6BAAA;AAnMN;AAqLA;EAiBM,aAAA;AAnMN;AAwMA;EACE,uBAAA;EACA,iBAAA;AAtMF;AAyMA;EACE,2BAAA;AAvMF;AAwME;EACE,2BAAA;AAtMJ;AA0MA;EACE,eAAA;EACA,0BAAA;EACA,WAAA;AAxMF;AA2MA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AAzMF;AA2MA;EACE,kBAAA;EACA,mBAAA;EACA,gCAAA;AAzMF;AA4MA;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AA1MF;AAoMA;EAQI,gBAAA;EACA,2BAAA;AAzMJ;AAgMA;EAYI,UAAA;EACA,SAAA;AAzMJ;AA4LA;EAgBI,0BAAA;EACA,aAAA;EAnjCF,aAAA;EAoBA,mBAAA;EA6QA,uBAAA;EAhBA,mBAAA;AA6lBF;AAoLA;EAliCE,aAAA;EAwBA,sBAAA;EAyPA,mBAAA;EA2yBI,YAAA;EACA,8BAAA;AAxMN;AA6KA;EA6BQ,YAAA;EACA,WAAA;AAvMR;AAyKA;EAliCE,aAAA;EAwBA,sBAAA;AAq2BF;AA6MA;EACE,cAAA;AA3MF;AA8MA;EA9kCE,aAAA;EAoBA,mBAAA;AAg3BF;AA0MA;EAzzBE,kBAAA;EA8zBE,eAAA;AA3MJ;AA+MA;EACE,0BAAA;AA7MF;AAgNA;EACE,sBAAA;EACA,UAAA;AA9MF;AAiNA;EACE,mCAAA;AA/MF;AAkNA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AAhNF;AAmNA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAjNF;AAmNA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAjNF;AAoNA;EAEI,UAAA;EACA,6BAAA;AAnNJ;AAgNA;EAMI,YAAA;AAnNJ;AAuNA;EACE,4BAAA;AArNF;AAwNA;EACE,sBAAA;AAtNF;AAyNA;EACE,wBAAA;AAvNF;AA0NA;EACE,qBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;AAxNF;AA2NA;EACE,iBAAA;AAzNF;AA4NA;EACE,WAAA;AA1NF;AA6NA;EACE,yBAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCAAA;AA3NF;AA8NA;EACE,eAAA;EACA,YAAA;EACA,qBAAA;AA5NF;AA+NA;EACE,eAAA;EACA,YAAA;AA7NF;AAgOA;EACE,qBAAA;EACA,eAAA;EACA,YAAA;EACA,qCAAA;AA9NF;AAiOA;EACE,4BAAA;AA/NF;AAkOA;EACE,mBAAA;EACA,4BAAA;AAhOF;AAkOA;EACE,eAAA;EACA,oBAAA;AAhOF;AAmOA;EACE,UAAA;AAjOF;AAoOA;EACE,mBAAA;AAlOF;AAsOA;EACE,aAAA;EACA,oDAAA;EACA,QAAA;AApOF;AAuOA;EACE,aAAA;EACA,oDAAA;AArOF;AACA;;;CAGC;AA2OD;EACE;IAEI,yBAAA;IACA,qBAAA;IACA,eAAA;IACA,sBAAA;IACA,0BAAA;EA1OJ;EA6OA;IAEI,UAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;IACA,cAAA;EA5OJ;AACF;AA+OA;EACE;IAEI,qBAAA;IACA,eAAA;IACA,sBAAA;IACA,0BAAA;EA9OJ;EAiPA;IAEI,UAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;IACA,cAAA;EAhPJ;AACF;AACA;;;CAGC;AAqPD;EACE;IAEI,yBAAA;IACA,qBAAA;IACA,eAAA;IACA,sBAAA;IACA,0BAAA;EApPJ;EAuPA;IAEI,UAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;IACA,cAAA;EAtPJ;AACF;AAyPA;EACE;IAEI,qBAAA;IACA,eAAA;IACA,sBAAA;IACA,0BAAA;EAxPJ;EA2PA;IAEI,UAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;IACA,cAAA;EA1PJ;AACF;AACA;;;CAGC;AA+PD;EACE;IAEI,yBAAA;IACA,qBAAA;IACA,eAAA;IACA,sBAAA;IACA,0BAAA;EA9PJ;EAiQA;IAEI,UAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;IACA,cAAA;EAhQJ;AACF;AAmQA;EACE;IAEI,qBAAA;IACA,eAAA;IACA,sBAAA;IACA,0BAAA;EAlQJ;EAqQA;IAEI,UAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;IACA,cAAA;EApQJ;AACF;AAwQA;EAnhCE,eAAA;EAlFA,4BAAA;EAwmCA,0BAAA;EACA,uBAAA;AAtQF;AAyQA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,oBAAA;AAvQF;AAyQA;EACE,aAAA;AAvQF;AA0QA;EACE,2CAAA;AAxQF;AAuQA;;;;EAMI,eAAA;EACA,qCAAA;AAvQJ;AAgQA;EAUI,qBAAA;AAvQJ;AA6PA;EAaI,wCAAA;AAvQJ;AA2QA;EACE,aAAA;EAEA,oDAAA;AA1QF;AA8QA;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;AA5QF;AA8QE;EACE,UAAA;AA5QJ;AA+QE;EACE,UAAA;AA7QJ;AAiRA;EACE,UAAA;AA/QF","sourcesContent":["html,\nbody,\n#root {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  font-size: small;\n\n  &#root {\n    overflow: hidden;\n  }\n}\n\nbody {\n  font-family: 'NeueFrutigerWorldW02-Regular', 'sans-serif' !important;\n  overflow: hidden;\n}\n\nbody * {\n  font-family: 'NeueFrutigerWorldW02-Regular', 'sans-serif' !important;\n}\n* {\n  box-sizing: border-box;\n}\n@philips-blue: #1474a4;\n@philips-gray: #eeeeee;\n@philips-green: #93c47d;\n@philips-orange: #f6b26b;\n@philips-yellow: #f3f66b;\n@philips-red: red;\n\n@dialogActionDivider: rgba(0, 0, 0, 0.12);\n\n@font-face {\n  font-family: 'NeueFrutigerWorldW02-Regular';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url('../public/NeueFrutigerWorldW02-Regular.woff2');\n}\n\n//Scroll bar Stylings\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n::-webkit-scrollbar-thumb {\n  background: #5a9dbf;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #5a9dbf;\n}\n.d-flex {\n  display: flex;\n}\n\n.d-inline-flex {\n  display: inline-flex;\n}\n\n.d-block {\n  display: block;\n}\n\n.d-inline-block {\n  display: inline-block;\n}\n\n.d-inline {\n  display: inline;\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.squareSize {\n  width: 100%;\n  height: 100%;\n}\n\n.w-0 {\n  width: 0%;\n}\n\n.w-25 {\n  width: 25%;\n}\n\n.w-50 {\n  width: 50%;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto;\n}\n\n.w-25ch {\n  width: '25ch';\n}\n\n.w-10 {\n  width: 10%;\n}\n\n.w-20 {\n  width: 20%;\n}\n\n.w-40 {\n  width: 40%;\n}\n\n.w-45 {\n  width: 45%;\n}\n\n.w-90 {\n  width: 90%;\n}\n\n.mw-0 {\n  max-width: 0%;\n}\n\n.mw-25 {\n  max-width: 25%;\n}\n\n.mw-50 {\n  max-width: 50%;\n}\n\n.mw-100 {\n  max-width: 100%;\n}\n\n.mw-10 {\n  max-width: 10%;\n}\n\n.h-0 {\n  height: 0%;\n}\n\n.h-25 {\n  height: 25%;\n}\n\n.h-50 {\n  height: 50%;\n}\n\n.h-100 {\n  height: 100%;\n}\n\n.h-auto {\n  height: auto;\n}\n.h-inherit {\n  height: inherit;\n}\n.m-0 {\n  margin: 0;\n}\n\n.mt-0 {\n  margin-top: 0;\n}\n.mt-1em {\n  margin-top: 1em !important;\n}\n.mr-0 {\n  margin-right: 0;\n}\n\n.mb-0 {\n  margin-bottom: 0;\n}\n\n.ml-0 {\n  margin-left: 0;\n}\n\n.ml-10 {\n  margin-left: 10px !important;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.p-0 {\n  padding: 0px !important;\n}\n\n.p-5px {\n  padding: 5px;\n}\n\n.p-10px {\n  padding: 10px;\n}\n\n.p-20px {\n  padding: 20px;\n}\n\n.p-15px {\n  padding: 15px;\n}\n\n.p-1rem {\n  padding: 1rem;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pt-1 {\n  padding-top: 1em !important;\n}\n\n.pt-10 {\n  padding-top: 10px !important;\n}\n\n.pl-0 {\n  padding-left: 0;\n}\n.pl-2 {\n  padding-left: 2px !important;\n}\n\n.pr-0 {\n  padding-right: 0;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pb-1 {\n  padding-bottom: 1em !important;\n}\n\n.pb-2 {\n  padding-bottom: 2em !important;\n}\n\n.py-0 {\n  .pt-0();\n  .pb-0();\n}\n\n.px-0 {\n  .pr-0();\n  .pl-0();\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflowX-auto {\n  overflow-x: auto;\n}\n\n.overflowY-auto {\n  overflow-y: auto;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.align-start {\n  align-items: flex-start !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n\n.ws-nowrap {\n  white-space: nowrap !important;\n}\n\n.vertical-middle {\n  vertical-align: middle;\n}\n\n.align-top {\n  align-items: flex-start;\n}\n\n.align-center {\n  align-items: center;\n}\n\n.alignself-center {\n  align-self: center;\n}\n\n.alignself-start {\n  align-self: self-start;\n}\n\n.justify-left {\n  justify-content: left !important;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-right {\n  justify-content: right;\n}\n.justify-end {\n  justify-content: flex-end;\n}\n.justify-spacebetween {\n  justify-content: space-between;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\n.warning {\n  color: #ff9800 !important;\n}\n\n.bottomUnset {\n  border-bottom: unset;\n}\n\n.rowFlex {\n  .d-flex();\n  .flex-row();\n}\n\n.colFlex {\n  .d-flex();\n  .flex-column();\n}\n\n.squareSize {\n  width: 100%;\n  height: 100%;\n}\n\n.flex-start {\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-default {\n  cursor: default !important;\n}\n\n.position-absolute {\n  position: absolute;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflowY-hidden {\n  overflow-y: hidden;\n}\n\n.overflow-ellipsis {\n  text-overflow: ellipsis;\n}\n\n.overflowWrap-anywhere {\n  overflow-wrap: anywhere;\n}\n\n.zindex-100 {\n  z-index: 100;\n}\n\n.border-radius-0 {\n  border-radius: 0 !important;\n}\n\n.bg-philips-blue {\n  background-color: @philips-blue;\n}\n\n.bg-lightgray {\n  background-color: lightgray;\n}\n\n.b-0 {\n  border: 0;\n}\n\n.PhilipsBlue {\n  color: @philips-blue;\n}\n.PhilipsRed {\n  color: @philips-red;\n}\n\n.white-color {\n  color: white;\n}\n\n.headerStyle {\n  &.root {\n    .rowFlex();\n    .flex-start();\n  }\n\n  .toolbar {\n    .rowFlex();\n    justify-content: space-between;\n    align-items: center;\n    .squareSize();\n    padding: 0 10px;\n    min-height: 3rem;\n    padding-top: 0.3rem !important;\n    padding-bottom: 0.3rem !important;\n  }\n\n  .toolbarSection {\n    .rowFlex();\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .tooltip {\n    margin: 2;\n  }\n\n  .button-icon {\n    .cursor-pointer();\n    color: #ffffff;\n  }\n}\n.zoom80 {\n  zoom: 80%;\n}\n\n.userPanelIconButton {\n  .cursor-pointer();\n  color: white !important;\n  .p-5px() !important;\n\n  .userProfileIcon {\n    height: 2rem;\n    width: 2rem;\n  }\n}\n\n.popperStyle {\n  &.arrow {\n    width: 3em;\n    height: 3em;\n  }\n\n  &::before {\n    content: '';\n    margin: auto;\n    .d-block();\n    .w-0();\n    border-style: solid;\n    border-width: 0px 1em 1em;\n    border-color: transparent transparent rgb(255, 255, 255);\n    margin-top: -0.4rem;\n  }\n}\n.appRouter {\n  &.root {\n    .colFlex();\n    .flex-start();\n    .squareSize();\n    padding: 0;\n  }\n\n  .secondaryHeader {\n    .d-flex();\n    .flex-row();\n    .justify-spacebetween();\n    .align-center();\n    width: 100%;\n  }\n\n  .appRouterContent {\n    .d-flex();\n    .flex-row();\n    .justify-spacebetween();\n    .squareSize();\n    overflow: hidden;\n  }\n\n  .divider {\n    width: 100%;\n  }\n}\n.footer {\n  &.root {\n    .d-flex();\n    .w-100();\n    font-size: 12px;\n    justify-content: space-between;\n    padding-left: 1em;\n    padding-right: 1em;\n  }\n\n  .env {\n    margin-right: 1px;\n    padding-right: 1px;\n  }\n\n  .termsAndCondition {\n    .d-flex();\n    .flex-row();\n    margin-right: 1px;\n  }\n\n  &.bg-gray {\n    background-color: @philips-gray;\n  }\n\n  &.bg-green {\n    background-color: @philips-green;\n  }\n\n  &.bg-orange {\n    background-color: @philips-orange;\n  }\n\n  &.bg-yellow {\n    background-color: @philips-yellow;\n  }\n}\n\n.termsAndCondition-dialog {\n  .paperClass {\n    width: 45%;\n    height: 60vh;\n  }\n}\n\n.termsAndConditionStyle {\n  .d-flex();\n  .flex-row();\n  margin-right: 1px;\n\n  .title {\n    .cursor-pointer();\n    text-decoration: underline;\n    color: blue;\n  }\n}\n.drawerOpen {\n  width: 200px;\n}\n.middle-container {\n  .overflow-auto();\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100% !important;\n  height: 100%;\n  padding: 0.4em 1.5em;\n  .mainHeader {\n    margin-top: 0em;\n    margin-bottom: 0.2em;\n  }\n}\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-tabs {\n  .text-capitalize();\n  .align-center();\n  .justify-left();\n  .text-left();\n  min-height: 50px;\n  padding: 10px;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.tab-drawer-tabs {\n  color: #1474a4 !important;\n  background: rgba(199, 224, 244, 1) !important;\n  font-weight: 800 !important;\n}\n\n.navigateTabLabel {\n  writing-mode: tb-rl;\n  height: inherit;\n  cursor: pointer;\n\n  font-size: 1.25rem;\n  white-space: nowrap;\n}\n\n.tabDrawerMini {\n  width: 3.5rem;\n  height: inherit;\n  text-align: center;\n  background: #eeeeee;\n  z-index: 100;\n}\n\n.pinIcon {\n  font-size: 1.4rem !important;\n}\n\n.rotate180 {\n  transform: rotate(180deg);\n}\n\n.rotate270 {\n  transform: rotate(270deg);\n}\n\n.rotate90 {\n  transform: rotate(90deg);\n}\n\n.rotate0 {\n  transform: rotate(0deg);\n}\n\n.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium.left-arrow {\n  color: @philips-blue;\n  margin-left: 80%;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-tabs:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.toggleIcon:hover {\n  width: inherit !important;\n  border-radius: 0 !important;\n}\n\n.toggleIcon:focus {\n  width: inherit !important;\n  border-radius: 0 !important;\n}\n\n.text-align-end {\n  text-align: end;\n}\n\n.data-table {\n  margin-top: 0.5em;\n}\n\n.common-data-table {\n  height: 78% !important;\n  .MuiTableCell-head {\n    font-weight: 500;\n    font-size: 14px;\n  }\n  .link {\n    .cursor-pointer();\n    text-decoration: underline;\n    color: blue;\n  }\n}\n\n.delete-button {\n  .text-capitalize();\n  color: red;\n}\n\n.common-dialog-style {\n  .header {\n    .bg-philips-blue();\n    font-size: 1.2rem;\n    padding: 0.5rem;\n    border-bottom: 0.1rem solid @dialogActionDivider;\n    color: white;\n  }\n\n  .paper {\n    height: 60vh;\n  }\n\n  .dialogContent {\n    padding-top: 4vh !important;\n  }\n\n  .closeIcon {\n    .position-absolute();\n    right: 0px;\n    top: 0px;\n    color: white;\n  }\n\n  .footer {\n    background: rgb(238, 238, 238);\n    border-top: 0.1rem solid rgba(0, 0, 0, 0.12);\n  }\n}\n\n.alert-dialog {\n  .MuiDialog-container .MuiPaper-root {\n    min-width: 30%;\n  }\n  .MuiDialog-container .MuiPaper-root .MuiDialogContent-root {\n    padding-top: 1.5em;\n  }\n  .alertDialogContents {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    .alertIcon {\n      display: flex;\n      margin-right: 5%;\n      transform: scale(1.3);\n    }\n  }\n}\n\n.iframeDialogStyle {\n  .MuiPaper-root {\n    width: 80% !important;\n    height: 90vh !important;\n    max-width: 100% !important;\n  }\n  .closeIcon {\n    .position-absolute();\n    right: 0px;\n    top: 0px;\n    color: #fff;\n  }\n  .header {\n    background-color: #1474a4;\n    font-size: 1.2rem;\n    padding: 0.5rem;\n    border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);\n    color: white;\n  }\n  .MuiDialogContent-root {\n    padding: 5px !important;\n  }\n}\n\n.manipulationDialog {\n  .MuiPaper-root {\n    width: 40%;\n    min-height: 50%;\n    height: 50%;\n    max-height: 70%;\n    max-width: 100%;\n  }\n  .title {\n    .h-auto();\n    text-align: left;\n  }\n  .MuiAlert-root {\n    height: auto !important;\n    width: auto !important;\n  }\n}\n\n.xLargerDialog {\n  .MuiPaper-root {\n    width: 70% !important;\n    height: 80% !important;\n  }\n  .detailsTable {\n    margin-top: 1vh !important;\n    height: 64vh !important;\n    width: 100% !important;\n    .MuiTableCell-head {\n      .p-5px();\n    }\n    .MuiTableCell-body {\n      .p-5px();\n    }\n    div {\n      position: absolute;\n      width: max-content;\n      margin: 18% 0 0 40%;\n    }\n  }\n}\n\n.largerManipulationDialog {\n  .MuiPaper-root {\n    width: 60% !important;\n    min-height: 50%;\n    height: 80% !important;\n    max-height: 80% !important;\n  }\n  .featureFlagsTab {\n    .p-0();\n    .featureFlagsTable {\n      height: 50vh !important;\n      margin-top: 0px !important;\n      width: 100% !important;\n      overflow-x: hidden;\n    }\n  }\n  .permissionsTab {\n    .api-data-table {\n      height: 55vh !important;\n      margin-top: 0px !important;\n      width: 100% !important;\n      overflow-x: hidden;\n    }\n  }\n}\n\n.rolesChip {\n  margin-right: 0.5em;\n}\n\n.alert-box {\n  width: inherit;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  .alert {\n    width: 30%;\n  }\n}\n\n.MuiAlert-message {\n  overflow: hidden !important;\n}\n\n.formActionButtons {\n  display: flex;\n  justify-content: flex-end;\n  bottom: 0;\n  position: absolute;\n  width: 100%;\n  left: 0;\n  padding-bottom: 1em;\n  background-color: #fff;\n  z-index: 100;\n  button {\n    margin-right: 0.5em;\n  }\n}\n\n.manipulationForm {\n  .errorMessage {\n    margin-top: 0.5vh;\n    width: 100% !important;\n    max-height: 100% !important;\n    align-items: center;\n  }\n}\n\n.manipulationBox {\n  width: 100%;\n}\n\n.userManipulationTabs {\n  width: 100%;\n\n  .dialog-tab {\n    padding-left: 1%;\n    padding-right: 1%;\n  }\n\n  .personalDetailsTab {\n    display: inline;\n    padding-bottom: 0px !important;\n    .personalDetailsForm {\n      // width: 30vw;\n      .errorMessage {\n        margin-top: 0.5vh;\n      }\n    }\n  }\n\n  .roleAssociationTab {\n    .p-0();\n    width: 100% !important;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    .data-table {\n      height: auto !important;\n      margin-top: 0px !important;\n      width: 100% !important;\n      .MuiTableCell-head {\n        .p-0();\n      }\n      .MuiTableCell-body {\n        .p-0();\n      }\n    }\n    .formActionButtons {\n      padding-top: 1em;\n    }\n  }\n\n  .permissionsTab {\n    .p-0();\n    .MuiPaper-root {\n      min-width: 100% !important;\n      min-height: 52vh !important;\n    }\n    .data-table {\n      height: 40vh !important;\n      margin-top: 0px !important;\n    }\n  }\n}\n\n.noDataFound {\n  .text-center() !important;\n}\n\n.searchIconForColumn {\n  .rowFlex();\n  .align-center();\n}\n\n.search-bar.MuiAutocomplete-root {\n  width: 20em !important;\n  position: relative;\n  bottom: 3px;\n  padding-top: 0.3rem;\n  .search-inner-text > div {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n    margin-left: 0.7vw;\n  }\n  .search-inner-text > div > div > button {\n    // To make the clear icon visible\n    visibility: visible !important;\n  }\n  .search-inner-text > div > div > svg {\n    // To set the icon in place\n    position: absolute !important;\n    top: 1.1vh !important;\n    left: 0.2vw !important;\n  }\n}\n\niframe {\n  width: 100%;\n  height: 98%;\n  border: 0px;\n}\n\n.warningIcon {\n  color: #f7d368;\n}\n\n.successIcon {\n  color: @philips-green;\n}\n\n.headerDialog {\n  background: @philips-blue;\n  font-size: 1.2rem !important;\n  padding: 0.5rem !important;\n  color: white;\n}\n\n.dialog-content {\n  padding-top: 1em !important;\n  padding-bottom: 1em !important;\n}\n\n.exportIcon {\n  .PhilipsBlue() !important;\n}\n\n.checkboxDropdown {\n  .p-0();\n  padding-right: 1% !important;\n}\n\n.inputFieldset {\n  box-sizing: border-box;\n  border-radius: 4px;\n  border-width: 1.5px;\n  border-color: rgba(0, 0, 0, 0.2);\n  border-style: solid;\n  width: 100%;\n  height: fit-content;\n  padding-bottom: 4px !important;\n  padding-left: 0.8rem !important;\n  margin-inline-start: 0px !important;\n  &:hover:not(:focus):not(:focus-within) {\n    border-color: rgba(0, 0, 0, 0.87);\n  }\n  &:focus-within {\n    border-color: #1173a3;\n  }\n\n  & > legend.inputLegend {\n    color: rgba(0, 0, 0, 0.6);\n    word-break: break-all;\n  }\n  &:focus-within > legend.inputLegend {\n    color: @philips-blue;\n  }\n  &:hover:not(:focus):not(:focus-within) > legend.inputLegend {\n    color: rgba(0, 0, 0, 0.87);\n  }\n\n  .success-dialog {\n    .MuiDialog-paper {\n      max-width: 600px !important;\n    }\n    .apiKey {\n      max-width: 60ch;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n}\n\n.maintenanceTable {\n  height: 86%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  .recordPicker {\n    position: relative;\n    bottom: 3px;\n    padding-top: 0.3rem;\n    padding-left: 0.3rem;\n  }\n  .common-data-table {\n    .MuiTableCell-head,\n    .MuiTableCell-body {\n      padding: 0.5rem 0 0.5rem 1rem;\n    }\n    .MuiTableCell-head {\n      min-width: 65;\n    }\n  }\n}\n\n.dialog-mode {\n  height: 100% !important;\n  padding-top: 10px;\n}\n\n.statusFailed {\n  background-color: #ffa07a73;\n  &:hover:not(:focus):not(:focus-within) {\n    background-color: #ffa07a73;\n  }\n}\n\n.link {\n  cursor: pointer;\n  text-decoration: underline;\n  color: blue;\n}\n\n.show-alert {\n  position: absolute;\n  top: 18px;\n  z-index: 100;\n  width: 90%;\n}\n.text-area {\n  border-radius: 4px;\n  border-width: 1.5px;\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.unsupported-browser {\n  display: inline-block;\n  text-align: center;\n  width: 45%;\n  height: 90%;\n  margin-left: auto;\n  margin-right: auto;\n  .message {\n    text-align: left;\n    padding-top: 5px !important;\n  }\n  .unsupported-browser-image {\n    height: 50;\n    width: 40;\n  }\n  .versionSupported {\n    z-index: 150000 !important;\n    padding: 10px;\n    .d-flex();\n    .flex-row();\n    .justify-center();\n    .align-center();\n    .browserBox {\n      .d-flex();\n      .flex-column();\n      .align-center();\n      margin: 0 2%;\n      justify-content: space-between;\n      img {\n        height: 35px;\n        width: 35px;\n      }\n      .browserDetails {\n        .d-flex();\n        .flex-column();\n      }\n    }\n  }\n}\n\n.common-btn {\n  height: 2.5rem;\n}\n\n.priceListMapSearchBar {\n  .d-flex();\n  .flex-row();\n  .records {\n    .alignself-center();\n    margin-left: 2%;\n  }\n}\n\n.headerLogo {\n  cursor: pointer !important;\n}\n\n.cellWithValueAsNo {\n  background-color: pink;\n  color: red;\n}\n\n.circularProgress-upload {\n  animation: blink 1s linear infinite;\n}\n\n.loading-message {\n  display: block;\n  text-align: center;\n  background: white;\n  padding: 50px;\n  box-shadow: 1px 1px 2px 1px grey;\n  border-radius: 3px;\n  width: 30%;\n  min-width: 30%;\n}\n\n.squareLegend {\n  width: 15px;\n  height: 15px;\n  margin-right: 5px;\n}\n.circleLegend {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  margin-right: 5px;\n}\n\n.updateCell {\n  .removed {\n    color: red;\n    text-decoration: line-through;\n  }\n  .added {\n    color: green;\n  }\n}\n\n.cellStylesPHAdded {\n  background-color: lightgreen;\n}\n\n.cellStylesPHDeleted {\n  background-color: pink;\n}\n\n.cellStylesPHUpdated {\n  background-color: yellow;\n}\n\n.span-overflow {\n  display: inline-block;\n  max-width: 38%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  position: relative;\n  top: 15%;\n}\n\n.file-upload-box {\n  display: contents;\n}\n\n.tabpanel-manipulation {\n  width: 100%;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.permission-tab-panel {\n  color: #1474a4 !important;\n  background: rgba(199, 224, 244, 1) !important;\n  font-weight: 800 !important;\n  justify-content: center !important;\n}\n\n.selected-enum-option {\n  cursor: pointer;\n  padding: 3px;\n  background: lightblue;\n}\n\n.default-enum-option {\n  cursor: pointer;\n  padding: 2px;\n}\n\n.default-enum-option:hover {\n  background: lightblue;\n  cursor: pointer;\n  padding: 3px;\n  animation: inputHighlighter 0.3s ease;\n}\n\n.application-radio {\n  margin-right: 5px !important;\n}\n\n.technical-info {\n  margin-right: 0.5em;\n  margin-top: 0.2em !important;\n}\n.feature-association-header {\n  margin-top: 0em;\n  margin-bottom: 0.2em;\n}\n\n.asterisk {\n  color: red;\n}\n\n.property-header {\n  background: #faebd7;\n}\n\n// Responsive checkbox grid classes\n.checkbox-grid-2col {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(150px, 1fr));\n  gap: 8px;\n}\n\n.checkbox-grid-3col {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(139px, 1fr));\n}\n\n// Media queries\n\n/* \n  ##Device = Ipad mini (portrait)\n  ##Screen = B/w 768px to 1024px\n*/\n\n@media all and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {\n  .largerManipulationDialog {\n    .MuiPaper-root {\n      min-width: 80% !important;\n      width: 80% !important;\n      min-height: 50%;\n      height: 80% !important;\n      max-height: 80% !important;\n    }\n  }\n  .manipulationDialog {\n    .MuiPaper-root {\n      width: 50%;\n      min-height: 40%;\n      height: 40%;\n      max-height: 60%;\n      max-width: 70%;\n    }\n  }\n}\n@media all and (device-width: 1024px) and (device-height: 768px) and (orientation: landscape) {\n  .largerManipulationDialog {\n    .MuiPaper-root {\n      width: 70% !important;\n      min-height: 50%;\n      height: 80% !important;\n      max-height: 80% !important;\n    }\n  }\n  .manipulationDialog {\n    .MuiPaper-root {\n      width: 45%;\n      min-height: 50%;\n      height: 50%;\n      max-height: 60%;\n      max-width: 70%;\n    }\n  }\n}\n\n/* \n  ##Device = Ipad Air (portrait)\n  ##Screen = B/w 820px to 1180px\n*/\n\n@media all and (device-width: 820px) and (device-height: 1180px) and (orientation: portrait) {\n  .largerManipulationDialog {\n    .MuiPaper-root {\n      min-width: 80% !important;\n      width: 80% !important;\n      min-height: 50%;\n      height: 70% !important;\n      max-height: 80% !important;\n    }\n  }\n  .manipulationDialog {\n    .MuiPaper-root {\n      width: 50%;\n      min-height: 40%;\n      height: 40%;\n      max-height: 60%;\n      max-width: 70%;\n    }\n  }\n}\n@media all and (device-width: 1180px) and (device-height: 820px) and (orientation: landscape) {\n  .largerManipulationDialog {\n    .MuiPaper-root {\n      width: 70% !important;\n      min-height: 50%;\n      height: 80% !important;\n      max-height: 80% !important;\n    }\n  }\n  .manipulationDialog {\n    .MuiPaper-root {\n      width: 45%;\n      min-height: 50%;\n      height: 50%;\n      max-height: 60%;\n      max-width: 70%;\n    }\n  }\n}\n\n/* \n  ##Device = Ipad Air (portrait)\n  ##Screen = B/w  1024px to 1366px\n*/\n\n@media all and (device-width: 1024px) and (device-height: 1366px) and (orientation: portrait) {\n  .largerManipulationDialog {\n    .MuiPaper-root {\n      min-width: 80% !important;\n      width: 80% !important;\n      min-height: 50%;\n      height: 70% !important;\n      max-height: 80% !important;\n    }\n  }\n  .manipulationDialog {\n    .MuiPaper-root {\n      width: 50%;\n      min-height: 35%;\n      height: 35%;\n      max-height: 60%;\n      max-width: 65%;\n    }\n  }\n}\n@media all and (device-width: 1366px) and (device-height: 1024px) and (orientation: landscape) {\n  .largerManipulationDialog {\n    .MuiPaper-root {\n      width: 70% !important;\n      min-height: 50%;\n      height: 80% !important;\n      max-height: 80% !important;\n    }\n  }\n  .manipulationDialog {\n    .MuiPaper-root {\n      width: 40%;\n      min-height: 35%;\n      height: 35%;\n      max-height: 60%;\n      max-width: 65%;\n    }\n  }\n}\n\n.formLabel-login-error {\n  .cursor-pointer();\n  .text-bold() !important;\n  text-decoration: underline;\n  color: black !important;\n}\n\n.btn-plain {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  font: inherit;\n  font-family: inherit;\n  font-weight: inherit;\n}\n.hide {\n  display: none;\n}\n\nfieldset[disabled] {\n  border-color: rgba(0, 0, 0, 0.2) !important;\n  input,\n  legend,\n  .inputLegend,\n  span {\n    cursor: default;\n    color: rgba(0, 0, 0, 0.38) !important;\n  }\n  .asterisk {\n    color: red !important;\n  }\n  span:hover {\n    background-color: transparent !important;\n  }\n}\n\n.checkbox-grid {\n  display: grid;\n\n  grid-template-columns: repeat(3, minmax(139px, 1fr));\n}\n\n// PropertyManipulationForm styles\n.property-clear-icon-wrapper {\n  margin-right: 16px;\n  opacity: 0;\n  transition: opacity 0.2s;\n\n  .MuiSelect-select:hover ~ & {\n    opacity: 1;\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.property-type-restrict-message {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
